import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { useTranslation } from "@crehana/i18n";
import { localeEs, localePt } from "../i18n";
import { STUDY_PLAN_METRICS_TRANSLATION_KEY } from "../i18n/constants";
var locales = /*#__PURE__*/_objectSpread(/*#__PURE__*/_objectSpread({}, localeEs), localePt);
export var useLearningPlanTranslation = function useLearningPlanTranslation() {
  var _useTranslation = useTranslation(STUDY_PLAN_METRICS_TRANSLATION_KEY),
    t = _useTranslation.t,
    addResourceBundle = _useTranslation.addResourceBundle,
    languageKey = _useTranslation.languageKey;
  addResourceBundle(locales);
  return {
    t: t,
    languageKey: languageKey
  };
};